import React, { useContext, useEffect, useState } from 'react';
import { Panel } from "../../components/Panel";
import ClientDisplayComponentForm from "app/components/ClientDisplayComponentForm";
import IconComponent from "../../components/IconComponent";
import { useParams, Params } from 'react-router';
import { AppContext, AppContextType } from "../../context/AppContext";
import { ModelClient } from '@dia-ui/util_interlink-api';
import {getBreadcrumb, setBreadcrumb} from "../../components/Breadcrumb";
import { RouteItem, RouteItems } from "../../routes";

/**
 * ClientDisplay
 * @constructor
 */
export function ClientDisplay() {
  const Context: AppContextType = useContext(AppContext);
  const ROUTE_CONFIG: RouteItems = Context.getRoutes();

  const { id } = useParams();
  const [client, setClient] = useState<ModelClient>();

  useEffect(() => {
    const fetchClient = async () => {
      if (!id) return;

      const client: ModelClient = await ClientLoader(Context, id);

      setClient(client);
    };

    fetchClient();
  // eslint-disable-next-line
  }, [id]);

  return (
    <>
      <Panel
        header={
          <>
            <IconComponent iconName={ ROUTE_CONFIG.CLIENT_VIEW_EDIT.icon } />
            { getBreadcrumb("CLIENT_VIEW_EDIT") }
          </>
        }
      >
        { client && <ClientDisplayComponentForm client={ client } /> }
      </Panel>
    </>
  );
}

/**
 * ClientLoader
 * @param context
 * @param id
 * @constructor
 */
function ClientLoader(context: AppContextType, id: string): Promise<ModelClient> {
  return context.services.serviceClient.getById(id);
}

/**
 * ClientDisplayBreadcrumb
 * @param route
 * @param context
 * @param params
 * @constructor
 */
export function ClientDisplayBreadcrumb(route: RouteItem, context: AppContextType, params: Params<string>): string | undefined {
  (async () => {
    if (!params.id) return;

    const client: ModelClient = await ClientLoader(context, params.id);
    if (client.comment) {
      setBreadcrumb("CLIENT_VIEW_EDIT", client.comment, "append");
    }
  })();

  return route.title;
}
